var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.isEdit ? "编辑商品" : "新增商品",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: { close: _vm.onClose }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "left",
            "show-message": false
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "SKU编码", prop: "itemNo", required: "" } },
            [
              _c("el-input", {
                attrs: { maxlength: 32, disabled: !_vm.editSkuNo },
                model: {
                  value: _vm.form.itemNo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "itemNo", $$v)
                  },
                  expression: "form.itemNo"
                }
              })
            ],
            1
          ),
          !_vm.editSkuNo
            ? _c("el-form-item", [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    " " + _vm._s(this.$t("CargoMsg.Cargo_CheckSavePoInfoItem"))
                  )
                ])
              ])
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "中文品名", prop: "chineseCommodity" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.chineseCommodity,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "chineseCommodity", $$v)
                  },
                  expression: "form.chineseCommodity"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "英文品名",
                prop: "englishCommodity",
                required: ""
              }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.englishCommodity,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "englishCommodity", $$v)
                  },
                  expression: "form.englishCommodity"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "MFG号", prop: "mfg" } },
            [
              _c("el-input", {
                attrs: { maxlength: 100 },
                model: {
                  value: _vm.form.mfg,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "mfg", $$v)
                  },
                  expression: "form.mfg"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "件数", required: "", prop: "quantity" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.quantity,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "quantity", $$v)
                  },
                  expression: "form.quantity"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "HS Code", prop: "hsCode" } },
            [
              _c("el-input", {
                attrs: { maxlength: 20 },
                model: {
                  value: _vm.form.hsCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "hsCode", $$v)
                  },
                  expression: "form.hsCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-form", [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                  [_vm._v("保存")]
                ),
                _c("el-button", { on: { click: _vm.onClose } }, [
                  _vm._v("取消")
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }